import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../api/axiosInstance';
import AuthShell from '../components/public/AuthShell';

const isValidEmail = (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val.trim());

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [sentTo, setSentTo] = useState('');
  const [errorMessage, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setError('');

    if (!isValidEmail(email)) {
      setError('Please enter a valid email address.');
      return;
    }

    setIsLoading(true);
    try {
      await axiosInstance.post('/User/reset-password', { email: email.trim() });
      setSentTo(email.trim());
      setEmail('');
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to send reset link.');
    } finally {
      setIsLoading(false);
    }
  };

  if (sentTo) {
    return (
      <AuthShell title="Check your email" subtitle="If an account exists for that address, a reset link is on its way." status="success">
        <p className="auth-text">
          We sent it to <strong>{sentTo}</strong>. The link works for a limited time. Check your spam folder if you don't see it.
        </p>
        <div className="auth-stack">
          <Link to="/login" className="auth-btn auth-btn--block">
            Back to sign in
          </Link>
          <button type="button" className="auth-btn auth-btn--ghost auth-btn--block" onClick={() => setSentTo('')}>
            Use a different email
          </button>
        </div>
      </AuthShell>
    );
  }

  return (
    <AuthShell title="Forgot your password?" subtitle="Enter the email for your account and we'll send you a link to reset it.">
      {errorMessage && (
        <div className="auth-alert is-error" role="alert">
          {errorMessage}
        </div>
      )}

      <form onSubmit={handleForgotPassword} noValidate>
        <div className="auth-field">
          <label htmlFor="fp-email">Email</label>
          <input
            id="fp-email"
            type="email"
            className="auth-input"
            placeholder="you@yourhotel.com"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              if (errorMessage) setError('');
            }}
            disabled={isLoading}
            autoComplete="email"
            inputMode="email"
            required
          />
        </div>

        <button type="submit" className="auth-btn auth-btn--block" disabled={isLoading}>
          {isLoading ? 'Sending...' : 'Send reset link'}
        </button>
      </form>

      <p className="auth-links">
        Remembered it? <Link to="/login">Back to sign in</Link>
      </p>
    </AuthShell>
  );
};

export default ForgotPassword;
